import { render, staticRenderFns } from "./participantes.vue?vue&type=template&id=ec5e03fa&scoped=true&"
import script from "./participantes.vue?vue&type=script&lang=js&"
export * from "./participantes.vue?vue&type=script&lang=js&"
import style0 from "./participantes.vue?vue&type=style&index=0&id=ec5e03fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec5e03fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VSpacer})
